import { TEST_CREDENTIALS } from '../test-credentials.js';
import { TEST_CREDENTIAL_CATEGORIES } from '../test-credential-categories.js';
/** Returns categorized test credentials filtered by scope(s). */
export function getCategorizedTestCredentials(scopes) {
    const result = {};
    for (const [testCredentialKey, testCredential] of Object.entries(TEST_CREDENTIALS)) {
        const hasAMatchingScope = scopes === null || scopes === void 0 ? void 0 : scopes.some((scope) => {
            const testCredentialScopes = testCredential.scopes;
            return testCredentialScopes.includes(scope);
        });
        if (scopes && scopes.length && !hasAMatchingScope)
            continue;
        const categoryKey = testCredential.category;
        if (!(categoryKey in result)) {
            result[categoryKey] = {
                ...TEST_CREDENTIAL_CATEGORIES[categoryKey],
                credentials: {}
            };
        }
        result[categoryKey].credentials[testCredentialKey] = testCredential;
    }
    return result;
}
//# sourceMappingURL=get-categorized-test-credentials.js.map